import request from '@/utils/request';

/**
 * 获取停车场列表
 * @param {Object} params - 查询参数
 */
export function getParkingLotList(params) {
  return request({
    url: '/admin/parking/lot/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取停车场详情
 * @param {number} id - 停车场ID
 */
export function getParkingLotDetail(id) {
  return request({
    url: "/admin/store/parkingLot/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 新增停车场
 * @param {Object} data - 停车场数据
 */
export function addParkingLot(data) {
  return request({
    url: '/admin/store/parkingLot/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑停车场
 * @param {Object} data - 停车场数据
 */
export function updateParkingLot(data) {
  return request({
    url: '/admin/store/parkingLot/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除停车场
 * @param {number} id - 停车场ID
 */
export function deleteParkingLot(id) {
  return request({
    url: "/admin/store/parkingLot/delete/".concat(id),
    method: 'GET'
  });
}